export const getScriptureTranslationId = (
  scripture?: string | null
): string => {
  const id = (scripture || "").toLowerCase().replace(/ /g, "-")

  return `scripture-${id}`
}
